import React from 'react';
import { useNavigate } from 'react-router';
import { Button, Text, FlexGroup, FlexItem, Icon } from '@lithos';

export const FormProgressFeedback = ({ setupCompleted }: { setupCompleted?: boolean }) => {
  const navigate = useNavigate();

  return (
    <div>
      <FlexGroup direction="column" gapSize="4">
        <FlexItem>
          <FlexGroup direction="row" gapSize="2">
            <FlexItem grow={0}>
              <Icon icon="Check" type="color" size="m" />
            </FlexItem>
            <FlexItem>
              <Text>
                <h3>Databricks Configuration Updated</h3>
                <p>Your cluster configuration has been successfully updated.</p>
              </Text>
            </FlexItem>
          </FlexGroup>
        </FlexItem>
        {setupCompleted && (
          <FlexItem>
            <Button
              type="secondary"
              label={'Go to Data Platform'}
              onClick={() => {
                navigate('/data-platform');
              }}
            />
          </FlexItem>
        )}
      </FlexGroup>
    </div>
  );
};

export default FormProgressFeedback;
